module.exports = {
  'en': {
    'HRMS16XC1': {
      '10': 'For Year',
      '20': 'App. No.',
      '30': 'For Department',
      '40': 'Position',
      '50': 'Or Employee',
      '60': 'Emp. Code',
      '70': 'Emp. Name',
      '80': 'KPI No.',
      '90': 'Detail of KPI',
      '100': 'Target Value',
      '110': 'Date',
      '120': 'Achieved Value',
      '130': 'Unit',
      '140': 'Value',
      '150': 'Net Value',
      '160': 'Month',
      '170': 'For'
    }
  },
  'th': {
    'HRMS16XC1': {
      '10': 'สำหรับปี',
      '20': 'ครั้งที่',
      '30': 'สำหรับหน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'หรือ รหัสพนักงาน',
      '60': 'รหัสพนักงาน',
      '70': 'ชื่อ - นามสกุล',
      '80': 'ลำดับที่',
      '90': 'รายละเอียด KPI',
      '100': 'เป้าหมายที่กำหนด',
      '110': 'วันที่บันทึก',
      '120': 'Achieved Value',
      '130': 'หน่วย',
      '140': 'มูลค่า',
      '150': 'มูลค่าสะสม',
      '160': 'เดือน',
      '170': 'สำหรับ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms16x.js